// extracted by mini-css-extract-plugin
export default {"Select":"Select_OVeoa","Select_select":"Select_select_Lhngw"};